/* prettier-ignore */

import { inject, Injectable } from '@angular/core';
import { isNotSuccess, validateRoute } from './guards/custom-route.guard';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { ModalController } from '@ionic/angular';
import { GenerateRouteService } from './generate-route.service';
import { of } from 'rxjs';

type Result = { is_successful: true, content?: string, reason?: string } | { is_successful: false; reason: string };

@Injectable({ providedIn: 'root' })

export class AddItemToCustomRouteService {
    private _modalController = inject(ModalController);
    private _customRouteService = inject(NewCustomRouteService);
    private _generateRouteService = inject(GenerateRouteService);
    
    addItem(args: any){
        this._modalController?.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });

        const route = this._customRouteService.route();
        const ctx = validateRoute(route, args?.day);
        if (isNotSuccess(ctx)){
            return of<Result>(ctx);
        }
        
        if (!args.element_id) {
            return of<Result>({ 
                is_successful: false, 
                reason: 'element_id es obligatorio' 
            })
        }

        if (!args.type) {
            return of<Result>({ 
                is_successful: false, 
                reason: 'type es obligatorio' 
            })
        }

        if (!args.hour) {
            return of<Result>({ 
                is_successful: false, 
                reason: 'hour es obligatorio' 
            })
        }

        const foundItem = this._customRouteService.allItems?.find(
            item => Number(item.id) == Number(args?.element_id) && item.type == args?.type
        );

        if (!foundItem){
            return of<Result>({ 
                is_successful: false, 
                reason: 'No se ha encontrado el recurso a añadir' 
            })
        }

        const { indexDay, indexPoint } = this._customRouteService.getItemPositionFromTimeline(args);
        const item = { dayIndex: indexDay, pointIndex: indexPoint, item: foundItem};
        const checkItemtoAdd = this._customRouteService.checkItemToAdd(item);
        if (!checkItemtoAdd){
            return of<Result>({ 
                is_successful: false, 
                reason: 'No hay espacio disponible' 
            })
        }

        const status = this._customRouteService.addItem();
        const mappedRoute = this._generateRouteService.getCurrentRoute();

        return of<Result>({ 
            is_successful: true, 
            content: mappedRoute,
            reason: status === 'ok' ? '' : 'Elemento añadido fuera de horario' 
        })
    }
}